import { apiService, createRequestHeadersConfig } from 'shared/api'

import { GetPaymentLinkResponse } from './types'

const api = apiService()

interface PaymentMethodsPayload {
  token?: string
}

interface GetPaymentLinkPayload {
  orderId: string
  token?: string
}

export const getPaymentMethods = (payload: PaymentMethodsPayload) => {
  return api.get(`/payment-methods`, createRequestHeadersConfig(payload?.token))
}

export const getPaymentLinkForSaleOrder = (payload: GetPaymentLinkPayload) => {
  const response = api.get<GetPaymentLinkResponse>(
    `/sale-orders/${payload.orderId}/payment-link`,
    createRequestHeadersConfig(payload?.token)
  )

  return response
}

export const changePaymentMethodForSaleOrder = (payload: GetPaymentLinkPayload) => {
  return api.patch(
    `/sale-orders/${payload.orderId}/change-payment-method`,
    {},
    createRequestHeadersConfig(payload?.token)
  )
}
